export default __webpack_public_path__ + "static/media/polk_g_srank.d5f63624.png";